import React, { useRef, useState } from "react";
import { Box, Grid } from "@mui/material";
import "./video.css";
import { FiPlayCircle, FiPauseCircle } from "react-icons/fi";

const VideoComponent = ({
  node,
  width,
  height,
  iconFont,
  iconPositionTop,
  iconPositionLeft,
}) => {
  const { video } = node;
  const [videoMuted, setVideoMuted] = useState(true);
  const [videoPlayBtnVisibility, setVideoPlayBtnVisibility] = useState(true);
  const [videoPauseBtnVisibility, setVideoPauseBtnVisibility] = useState(false);
  const videoEl = useRef(null);

  const videoPlayPauseHandler = () => {
    if (videoMuted) {
      setVideoMuted(false);
      setVideoPlayBtnVisibility(false);
      setVideoPauseBtnVisibility(true);
      //videoEl.current.play();
    } else {
      setVideoMuted(true);
      setVideoPlayBtnVisibility(true);
      setVideoPauseBtnVisibility(false);
      //videoEl.current.pause();
    }
  };

  return (
    <Box>
      <Grid container>
        <Grid item xs={12} className="videoGrid">
          {video ? (
            <>
              <FiPlayCircle
                className="playbtn"
                onClick={videoPlayPauseHandler}
                style={{
                  display: videoPlayBtnVisibility ? "block" : "none",
                  fontSize: iconFont || "50px",
                  top: iconPositionTop || "50%",
                  left: iconPositionLeft || "50%",
                }}
              />

              <FiPauseCircle
                className="playbtn"
                onClick={videoPlayPauseHandler}
                style={{
                  display: videoPauseBtnVisibility ? "block" : "none",
                  fontSize: iconFont || "50px",
                  top: iconPositionTop || "50%",
                  left: iconPositionLeft || "50%",
                }}
              />

              <video
                width={width || "100%"}
                height={height}
                autoPlay
                muted={videoMuted}
                className="videoTag"
                ref={videoEl}
              >
                <source src={video} />
              </video>
            </>
          ) : (
            ""
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default VideoComponent;
